import {
    AimmaProductId,
    getLocalized,
    HealthLang,
    PRODUCT_CHIP_LABELS,
} from "./healthTypes";
import {
    healthLifecycleChipDeveloping,
    healthLifecycleChipReference,
    healthLifecycleChipReferenceStatic,
} from "./healthVisualStyles";

const UNDER_DEVELOPMENT_CHIP_IDS: AimmaProductId[] = ["aimma-nursing-robot"];

/** Lifecycle chip labels for under-development products (name only, no status suffix) */
const UNDER_DEVELOPMENT_CHIP_LABELS = {
    "aimma-nursing-robot": {
        En: "Aimma Nursing Robot",
        Zh: "Aimma 照護機器人",
        Jp: "Aimma 看護ロボット",
    },
} as const satisfies Partial<Record<AimmaProductId, Record<HealthLang, string>>>;

interface HealthLifecycleStageChipProps {
    productId: AimmaProductId;
    lang: HealthLang;
    onNavigateToModules?: () => void;
}

export function HealthLifecycleStageChip({
    productId,
    lang,
    onNavigateToModules,
}: HealthLifecycleStageChipProps) {
    const isDeveloping = UNDER_DEVELOPMENT_CHIP_IDS.includes(productId);
    const label =
        productId === "aimma-nursing-robot"
            ? getLocalized(UNDER_DEVELOPMENT_CHIP_LABELS["aimma-nursing-robot"], lang)
            : getLocalized(PRODUCT_CHIP_LABELS[productId], lang);

    if (isDeveloping) {
        return (
            <span className={healthLifecycleChipDeveloping} aria-label={label}>
                {label}
            </span>
        );
    }

    if (onNavigateToModules) {
        return (
            <button
                type="button"
                onClick={onNavigateToModules}
                className={healthLifecycleChipReference}
            >
                {label}
            </button>
        );
    }

    return <span className={healthLifecycleChipReferenceStatic}>{label}</span>;
}
